export default __webpack_public_path__ + "static/media/11-JioSavaan-White.bd6dc59e.png";